import { ExtendedEventBaseItem } from "./extended-event-base.item";
import { WaHelperService } from '../../wa-services/wa-helper-service';
import { SeriesStagesItem } from "./series-stages.info.item";

export class SeriesAmateursDetailItem extends SeriesStagesItem {
  intotal: boolean;
  score: number;
  date: string;



  constructor(SeriesStagesItemraw: any, waHelperService:WaHelperService ) {
    super(SeriesStagesItemraw, waHelperService)
    this.id = SeriesStagesItemraw.ID;
    this.name = SeriesStagesItemraw.Name;
    this.nameshort = SeriesStagesItemraw.NameShort;
    this.place = SeriesStagesItemraw.Place;
    this.country = SeriesStagesItemraw.Country;
    this.stage = SeriesStagesItemraw.Stage;
    this.intotal = SeriesStagesItemraw.inTotal;
    this.score=SeriesStagesItemraw.Score;
    this.date = SeriesStagesItemraw.Date;
  }
}
